// extracted by mini-css-extract-plugin
export default {"zoomModal":"A4-z"};